<div class="fluid-container">
    <div class="row pt-4 d-flex align-items-center">
        <div class="col-md-8 step-title p-0">
            <div class="page-header">
                <h2>Signatures & Generate Final</h2> 
                <p>Insert Signature</p>
              </div>
        </div>
       
        <div class="col-md-4 editBtn headerSubPortion px-0"> 
            <ul>
              <li class="col-auto px-0 firstPortion"> 
                <gc-status-update [stepDetails]="stepDetails" type="EDIT"></gc-status-update>
              </li>
              <li class="col-auto pr-0 pl-2 secondPortion">
                <lib-maximize-dialog-library [configData]="{'layoutCode':stepDetails?.stepActionList[0].layoutCode}"></lib-maximize-dialog-library>
            <i (click)="handleClose();" class="close-icon pi pi-times pull-right"></i>
              </li>
            </ul>
          </div>
    </div>
    <div class="row"> 
        <div class="col-md-12 p-0">
            <lib-assigning-task-library  [stepDetails]="stepDetails" (updateStatus)="updateStepStatus($event)">
            </lib-assigning-task-library>
        </div>
    </div>
    <p-divider></p-divider>

    <div class="col-12">
        <p-tabView styleClass="review-petition-tab-view">
            <p-tabPanel header="Signatures">
                <div class="petition-analysis-holder">
                    <div class="row mb-3">
                      <div class="col-12 pl-0">
                        <div class="row"> 
                          <div class="col-md-12 p-4 signatureContent">
                            <div class="row signatureType">
                              <div class="col-12 mb-2">
                                <p class="mb-0">Choose a <b>Signature Type</b> and select the applicable forms.</p>
                              </div>
                              <div class="col-12">
                                <div class="emailTemplate"> 
                                  <p-dropdown placeholder="Select Type" 
                                              optionLabel="signatureType" 
                                              optionValue="id"
                                              name="signatureType" 
                                              [options]="signatureTypeList" 
                                              class="w-100" 
                                              [(ngModel)]="signatureType"
                                              (onChange)="onChangeSignature($event.value)"
                                              > 
                                  </p-dropdown>
                                </div> 
                              </div>
                            </div>
                            <!-- Conditional divs -->
                            <form [formGroup]="additionalCoversForm" (ngSubmit)="onSignatureSubmit()">
                              <div class="row" *ngIf="signatureType === 'Signature1'">
                                <div class="col-12">
                                  <h6><b>Select signatories who will sign the forms</b></h6>
                                </div>
                                <div class="col-3 checkBoxPortion" *ngFor="let item of signatureInfo; let i = index;">
                                  <div class="customWrapper">
                                    <input 
                                    type="checkbox"
                                    [formControlName]="i"
                                    (change)="toggleVisibility($event, i)"
                                  />
                                  <label for="{{item.label}}">{{ item.label }}</label>
                                  </div>
                                  
                                  <label [ngClass]="{'avalible mb-0' : item?.signatureAvalible == true, 
                                  'notAvalible mb-0' : item?.signatureAvalible == false}">
                                  <i class="pi pi-info-circle" *ngIf="!item?.signatureAvalible" pTooltip="Signature is not available in the profile section."></i>
                                  {{item?.signatureAvalible ? 'Signature is Available' : 'Signature is Not Available'}}</label> 
                                </div>
                                <div class="col-12 requestForSignature">
                                  <button pButton 
                                          pRipple 
                                          type="submit" 
                                          label="Request for Signature Image" 
                                          icon="pi pi-info-circle" 
                                          iconPos="right" 
                                          class="p-button-raised p-button-text" 
                                          pTooltip="Notification will be triggered to upload/provide a digital signature in the profile section">
                                    </button>
                                </div>
                              </div>
                            </form>
                            <div *ngIf="signatureType === 'Signature2'">
                              <div class="row">
                                <div class="timeLinePortion">
                                  <ul class="timeline">
                                    <li class="timeline-item">
                                        <div class="circle">1</div>
                                    </li>
                                    <li class="timeline-item">
                                        <div class="circle">2</div>
                                    </li>
                                </ul>
                                </div>
                                <div class="col-11 p-0">
                                    <div class="row">
                                      
                                        <div class="col-6 p-0">
                                          <div class="col-12">
                                            <h6><b>Select signatories who will sign the forms</b></h6>
                                          </div>
                                          <form [formGroup]="signatoriesSignedForm" class="col-12 signedPortion">
                                          <div class="col-3 checkBoxPortion" *ngFor="let item of selectedSignatory; let j = index;">
                                            <div class="customWrapper">
                                              <input 
                                              type="checkbox"
                                              [formControlName]="j"
                                              (change)="toggleSignatoryVisibility($event, j)" 
                                            />
                                            <label for="{{item.label}}">{{ item.label }}</label>
                                            </div>
                                          </div>
                                        </form> 
                                        </div>
                                     
                                      <div class="col-6 p-0">
                                        <div class="col-12 warningMessage">
                                          <i class="pi pi-exclamation-triangle"></i>
                                          <label>
                                              To sign the form manually, you need to email the signatories with instructions to download the form. After signing it, they should either upload it back to the Imagility system or courier the form.
                                          </label> 
                                        </div>
                                      </div>
                                      <div class="col-12 p-0">
                                        <div class="row signedForms">
                                          <div class="col-12">
                                            <h6><b>How do you want the signatories to return the signed forms</b></h6>
                                          </div>
                                          <div class="col-md-12 signatureHead">
                                            <div class="p-field-radiobutton mb-0">
                                              <p-radioButton
                                                name="returnForm"
                                                value="type3"
                                                [(ngModel)]="returnForms"
                                                inputId="type3"
                                                (onClick)="onReturnForms('type3')"
                                              ></p-radioButton>
                                              <label>By Delivery Service</label>
                                            </div> 
                                            <div class="p-field-radiobutton ml-2 mb-0">
                                              <p-radioButton
                                                name="returnForm"
                                                value="type4"
                                                [(ngModel)]="returnForms"
                                                inputId="type4"
                                                (onClick)="onReturnForms('type4')"
                                              ></p-radioButton>
                                              <label>Sign and Upload Forms</label>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-12 mt-3 p-0"> 
                            <div class="row selectFormPortion">
                              <div class="col-6 subHeadFirst pt-3 pb-3">
                                <h5 *ngIf="signatureType === 'Signature1'">Select single or multiple and click on the generate signature button.</h5>
                                <h5 *ngIf="signatureType === 'Signature2'">Select forms that you want to send for signature</h5>
                              </div> 
                              <div class="col-6 subHeadSecond pt-3 pb-3">
                                <button pButton 
                                      pRipple 
                                      type="button" 
                                      label="RESEND EMAIL" 
                                      icon="pi pi-envelope" 
                                      iconPos="left" 
                                      class="p-button-raised p-button-text p-2 ml-3" 
                                      (click)="onClickEmail()"  
                                      [disabled]="checkedList && checkedList.length == 0 ? true : false" 
                                      *ngIf="isMailSent && signatureType == 'Signature2' && (listDocuments && listDocuments.length!==0)">
                                </button>
                                <button pButton 
                                      pRipple 
                                      type="button" 
                                      label="EMAIL" 
                                      icon="pi pi-envelope" 
                                      iconPos="right" 
                                      class="p-button-raised p-button-text p-2 ml-3" 
                                      (click)="onClickEmail()" 
                                      [disabled]="checkedList && checkedList.length == 0 ? true : false" 
                                      *ngIf="!isMailSent && signatureType == 'Signature2' && (listDocuments && listDocuments.length!==0)">
                                </button>
                                <button pButton  
                                      pRipple 
                                      type="button" 
                                      label="GENERATE"
                                      iconPos="right" 
                                      class="p-button-raised p-button-text p-2 ml-3" 
                                      (click)="postGenerateDoc(checkedList,2)" 
                                      [disabled]="(!signatureInfoAvailable ? true: (checkedList && checkedList.length == 0 ? true : (!currentSelect ? true: false)))" 
                                      *ngIf="signatureType === 'Signature1' && (listDocuments && listDocuments.length!==0)">
                                </button>
                              </div>
                            </div> 
                            <div class="col-12 p-0" id="documentListForm">
                              <div class="row" class="review-accordion">
                                <table class="mat-elevation-z8 im-card-no-border-table im-card-table-noborder-spacing table"> 
                                  <thead>
                                    <tr> 
                                      <th>
                                        <input class="im-input mw-100"
                                          type="checkbox" 
                                          [(ngModel)]="masterSelected" 
                                          name="list_name" 
                                          (change)="checkUncheckAll()" 
                                          *ngIf="listDocuments && listDocuments.length!==0"
                                        />
                                      </th>
                                      <th>Form Name</th>
                                      <th>Signature Type</th>
                                      <th>Signatories</th>
                                      <th>Return Method</th>
                                      <th>Status</th>
                                      <th>Actions</th>
                                    </tr>
                                  </thead>
                                  <tbody *ngIf="(signatureType === 'Signature1' || signatureType === 'Signature2') && (listDocuments && listDocuments.length!==0)"> 
                                    <tr *ngFor="let item of listDocuments;let i=index">
                                      <td> 
                                        <input 
                                          type="checkbox" 
                                          [(ngModel)]="item.isSelected" 
                                          name="list_name" 
                                          value="{{item.id}}" 
                                          (change)="isAllSelected()"
                                        />
                                      </td>  
                                      <td>{{item.formType}}</td>
                                      <td>{{item?.signatureType}}</td>
                                      <td>
                                          <label *ngIf="item?.signatorList">{{item.signatorList}}</label>
                                      </td>
                                      <td>{{item.returnType=="" ? '--' : item.returnType}}</td>
                                      <td *ngIf="!item.signatureType"></td>
                                      <td 
                                        *ngIf="item.signatureType === 'Image Sign Type'" 
                                        [class.successInfo]="item.docGenerated === 1" 
                                        [class.warnInfo]="item.docGenerated !== 1">
                                        {{ item.docGenerated === 1 ? 'Form Generated' : 'Form Not Generated' }}
                                      </td>  
                                      <td 
                                        *ngIf="item.signatureType === 'Manual Sign Type'"  
                                        [class.successInfo]="item.docUploaded === 1" 
                                        [class.warnInfo]="item.docUploaded !== 1">
                                        {{ item.docUploaded === 1 ? 'File Uploaded' : (item.docUploaded === 2 ? 'Email Sent' : 'File Not Uploaded')}}
                                      </td>
                                      <td class="iconPortion">
                                        <p-button type="button" label="" icon="pi pi-cog" class="menu-button" iconPos="right" (click)="toggleMenu(item, i, $event)"></p-button>
                                        <div [hidden]="!(isMenuVisible && currentItem == i)" class="menu-container customToggle" id="uploadSign">
                                          <p *ngIf="((signatureType === 'Signature1') && !(!signatureInfoAvailable ? true: (checkedList && checkedList.length == 0 ? true : (!currentSelect ? true: false))))" (click)="onClickGenerateForm(item.pbSupportDocumentId)">Generate</p>
                                          <p (click)="viewPetition(item.fileLocation)">View Form</p>
                                          <p *ngIf="signatureType === 'Signature2' && item.id" (click)="onIndividualMail(item)">Resend Email</p>
                                          <p *ngIf="signatureType === 'Signature2' && returnForms == 'type3' && (item.returnType=='Delivery Service' || !item.returnType)">
                                            <p-fileUpload #fubauto mode="basic" chooseLabel="Upload Form" chooseIcon="" customUpload="true" name="demo[]" (uploadHandler)="onUploadHandle($event, fubauto, item.pbSupportDocumentId, item.formCode)" [accept]="acceptedTypes" [auto]="true">
                                            </p-fileUpload>
                                          </p>
                                          <p *ngIf="signatureType === 'Signature2' && item.docUploaded==1" (click)="download(item.fileLocation)">Download Form</p>
                                        </div>
                                      </td>   
                                    </tr>
                                  </tbody>
                                </table>
                                <div class="col-12 mt-3 p-0 noData" *ngIf="(signatureType === 'Signature1' || signatureType === 'Signature2') && (listDocuments && listDocuments.length==0)">
                                  <span class="pl-2">No Data</span>
                                </div>
                              </div>
                            </div> 
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
            </p-tabPanel>
            <p-tabPanel header="Generate & Print Petition">

            <div class="row pb-2">
            <div class="col-12 pl-0"><h6 class="mt-3">Click on the ‘Generate’ to view/ download the complete Petition PDF</h6></div>
          </div>

          <div class="row col-10 mb-3 petitionPortion p-2"> 
            <div  class="col-6 p-0 fullPetition">
              <label for="">Generate Full Petition</label>
            </div>
            <div  class="col-3 customGenerated p-0" *ngIf="enableViewDraftButton">
              <p class="mb-0 generated">Generated</p>
              <p class="mb-0 generatedDate">{{draftGeneratedDate}}</p>
            </div>
            <div class="col-3 customGenerated p-0" *ngIf="!enableViewDraftButton">
              <p class="mb-0 notGenerated">Not Generated</p>
            </div>
            <div  class="col-3 customActions p-0">
              <i *ngIf="enableViewDraftButton" class="pi pi-eye" (click)="viewPetition(fullPDFPath)" pTooltip="View"></i>
              <div class="fileDownload" *ngIf="enableViewDraftButton"> 
                <file-download-library [fileName]="fullPDFPath"
                [Path]="envPath + fullPDFPath.substring(23)">
              </file-download-library>
              </div>
              <i class="pi pi-file-plus" [ngClass]="disabledControls ? 'notAllowed' : ''" (click)="generatePetition(false)" pTooltip="Generate Petition"></i>  
            </div>
          </div> 

            <!-- <div class="row pt-3 border-top">
                <div class="col-md-6"></div>
                <div class="col-md-6 completeStep">
                <lib-step-status-update-component-library *ngIf="!isWizard"
                    [visaType]="inputData.caseType != 'I130' ? inputData.visatype : inputData.caseType" [stepDetails]="stepDetails"
                    [type]="typeOfButton"></lib-step-status-update-component-library>
                </div>
            </div> -->
            
            </p-tabPanel>
        </p-tabView>
    </div>

    <p-divider></p-divider>
    <div class="row pt-3">
        <div class="col-md-6"></div>
        <div class="col-md-6">
            <gc-status-update [stepDetails]="stepDetails" [type]="typeOfButton" [showPreviousStepBtn]="showPrev" [showNextStepBtn]="showNext" class="d-flex col-12 justify-content-end"></gc-status-update>
        </div>
    </div>
</div>



<div *ngIf="displayDialog">
    <p-dialog header="New Email" 
    [(visible)]="displayDialog" 
    modal="true" 
    appendTo="body" 
    [draggable]="false" 
    [resizable]="false" 
    [modal]="true" 
    [style]="{width: '80vw'}" > 
    <div class="message" mat-dialog-content id="emailSendContent">
    <form [formGroup]="definedtemplate" (ngSubmit)="onSubmit()">
  
    <div class="row newEmailHeaderMain">
    <div class="col-12 newEmailHeaderSub">
      <button pButton 
            pRipple 
            type="submit"   
            label="SEND" 
            icon="pi pi-send" 
            iconPos="left" 
            class="p-button-text p-1" 
            [disabled]="!definedtemplate.valid">
      </button>
      <div class="emailTemplate"> 
        <p class="mb-0">Email Template</p>
        <p-dropdown inputId="" 
                    placeholder="Select Template" 
                    optionLabel="templateName" 
                    optionValue="id"
                    name="templateName" 
                    formControlName="templatename"
                    [options]="templateList" 
                    class="w-100" 
                    (onChange)="onTemplateChange($event.value)"
                    > 
        </p-dropdown>
        <!-- <div *ngIf="definedtemplate.get('templatename').touched && definedtemplate.get('templatename').invalid">
          <span class="invalid-message" *ngIf="definedtemplate.get('templatename').errors?.required">
              {{getGlobalErrorMessages('REQUIRED')}}
          </span>
        </div> -->
      </div> 
    </div>
    </div>
    <div class="row newEmailContent">
    <div class="col-12">
      <label for="fromEmail" class="required">From</label>
      <p-chips
        id="fromEmail"
        formControlName="fromEmailids"
        separator=","
        placeholder="Enter emails"
        [disabled]="true"
      ></p-chips> 
      <div *ngIf="definedtemplate.get('fromEmailids').touched && definedtemplate.get('fromEmailids').invalid">
        <span class="invalid-message" *ngIf="definedtemplate.get('fromEmailids').errors?.required">
            {{getGlobalErrorMessages('REQUIRED')}}
        </span>
        <span class="invalid-message" *ngIf="definedtemplate.get('fromEmailids').errors?.pattern">
          {{getGlobalErrorMessages('INVALID_EMAIL')}}
        </span>
      </div>
    </div>
    <div class="col-12"> 
      <label for="toEmail" class="required">To</label>
      <p-chips
        id="toEmail"
        formControlName="toEmailids"
        separator=","
        placeholder="Enter emails"
      ></p-chips>
      <div *ngIf="definedtemplate.get('toEmailids').touched && definedtemplate.get('toEmailids').invalid">
        <span class="invalid-message" *ngIf="definedtemplate.get('toEmailids').errors?.required">
            {{getGlobalErrorMessages('REQUIRED')}}
        </span>
        <span class="invalid-message" *ngIf="definedtemplate.get('toEmailids').errors?.pattern">
          {{getGlobalErrorMessages('INVALID_EMAIL')}}
        </span>
      </div>
    </div> 
    <div class="col-12">
      <label for="ccEmail">Cc</label>
      <p-chips
        id="ccEmail"
        formControlName="ccEmailids"
        separator=","
        placeholder="Enter emails"
      ></p-chips>
      <div *ngIf="definedtemplate.get('ccEmailids').touched && definedtemplate.get('ccEmailids').invalid">
        <span class="invalid-message" *ngIf="definedtemplate.get('ccEmailids').errors?.pattern">
          {{getGlobalErrorMessages('INVALID_EMAIL')}}
        </span>
      </div>
    </div>
    <div class="col-12">
      <label for="subject" class="required">Subject</label><br>
      <input type="text" formControlName="subject" [readonly]="false" />
      <div *ngIf="definedtemplate.get('subject').touched && definedtemplate.get('subject').invalid">
        <span class="invalid-message" *ngIf="definedtemplate.get('subject').errors?.required">
            {{getGlobalErrorMessages('REQUIRED')}}
        </span>
      </div>
    </div>  
    <div class="col-12 mb-4">
      <label class="w-100 mb-0 required">Add Forms</label>
      <mat-form-field>
        <mat-select formControlName="addForms" multiple (selectionChange)="onChangeForms($event)">
          <mat-option *ngFor="let item of formsList" [value]="item.pbSupportDocumentId">{{item.formType}}</mat-option>
        </mat-select>
      </mat-form-field>  
  
      <mat-chip-list #chipList class="clsFileUploadMatChipList">
        <mat-chip *ngFor="let forms of displayForms" [selectable]="selectable"
                [removable]="removable" (removed)="remove(forms.pbSupportDocumentId)">
          {{forms.formType}}
          <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
        </mat-chip> 
      </mat-chip-list>  
      <div *ngIf="definedtemplate.get('addForms').touched && definedtemplate.get('addForms').invalid">
        <span class="invalid-message" *ngIf="definedtemplate.get('addForms').errors?.required">
            {{getGlobalErrorMessages('REQUIRED')}}
        </span>
      </div>
    </div>  
    <div class="col-12">
      <kendo-editor (valueChange)="createtemplatelibraryheaderValueChange($event)" #createtemplatelibraryheaderkendoeditor style="height: 400px;" name="createtemplatelibraryheaderTextContent" formControlName="emailbody">
        <kendo-toolbar>
            <kendo-toolbar-buttongroup>
                <kendo-toolbar-button kendoEditorBoldButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorItalicButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorUnderlineButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorStrikethroughButton></kendo-toolbar-button>
            </kendo-toolbar-buttongroup>
            <kendo-toolbar-buttongroup>
                <kendo-toolbar-button kendoEditorSubscriptButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorSuperscriptButton></kendo-toolbar-button>
            </kendo-toolbar-buttongroup>
            <kendo-toolbar-buttongroup>
                <kendo-toolbar-button kendoEditorAlignLeftButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorAlignCenterButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorAlignRightButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorAlignJustifyButton></kendo-toolbar-button>
            </kendo-toolbar-buttongroup>
            <kendo-toolbar-dropdownlist kendoEditorFormat></kendo-toolbar-dropdownlist>
            <kendo-toolbar-dropdownlist kendoEditorFontSize></kendo-toolbar-dropdownlist>
            <kendo-toolbar-dropdownlist kendoEditorFontFamily></kendo-toolbar-dropdownlist>
            <kendo-toolbar-colorpicker kendoEditorForeColor></kendo-toolbar-colorpicker>
            <kendo-toolbar-colorpicker kendoEditorBackColor view="gradient"></kendo-toolbar-colorpicker>
            <kendo-toolbar-buttongroup>
                <kendo-toolbar-button kendoEditorInsertUnorderedListButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorInsertOrderedListButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorIndentButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorOutdentButton></kendo-toolbar-button>
            </kendo-toolbar-buttongroup>
            <kendo-toolbar-button kendoEditorBlockquoteButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorSelectAllButton></kendo-toolbar-button>
            <kendo-toolbar-buttongroup>
                <kendo-toolbar-button kendoEditorUndoButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorRedoButton></kendo-toolbar-button>
            </kendo-toolbar-buttongroup>
            <kendo-toolbar-buttongroup>
                <kendo-toolbar-button kendoEditorCreateLinkButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorUnlinkButton></kendo-toolbar-button>
            </kendo-toolbar-buttongroup>
            <kendo-toolbar-button kendoEditorInsertFileButton></kendo-toolbar-button>                                
            <kendo-toolbar-button kendoEditorViewSourceButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorCleanFormattingButton></kendo-toolbar-button>
            <kendo-editor-insert-table-button></kendo-editor-insert-table-button>
            <kendo-toolbar-buttongroup>
                <kendo-toolbar-button kendoEditorAddColumnBeforeButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorAddColumnAfterButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorAddRowBeforeButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorAddRowAfterButton></kendo-toolbar-button>
            </kendo-toolbar-buttongroup>
            <kendo-toolbar-buttongroup>
                <kendo-toolbar-button kendoEditorDeleteColumnButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorDeleteRowButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorDeleteTableButton></kendo-toolbar-button>
            </kendo-toolbar-buttongroup>
            <kendo-toolbar-buttongroup>
                <kendo-toolbar-button kendoEditorMergeCellsButton></kendo-toolbar-button>
                <kendo-toolbar-button kendoEditorSplitCellButton></kendo-toolbar-button>
            </kendo-toolbar-buttongroup>
            <kendo-toolbar-button kendoEditorPrintButton></kendo-toolbar-button>
            <kendo-toolbar-buttongroup>
                <kendo-toolbar-button kendoEditorInsertImageButton></kendo-toolbar-button>
                <kendo-toolbar-button
                title="Upload’s Image at cursor point"
                text="Upload Image"
                (click)="createtemplatelibraryheaderimageuploaddialog()"
                ></kendo-toolbar-button>
            </kendo-toolbar-buttongroup>                                  
        </kendo-toolbar>
      </kendo-editor>
      <app-upload-image-dialog #createtemplatelibraryheaderupload [editor]="createtemplatelibraryheaderkendoeditor"></app-upload-image-dialog>
    </div>
    </div>
  
  
    </form>
    </div>
    <div mat-dialog-actions class="float-left">
    <!-- <button type="button" class="btn btn-primary mr-3" (click)="onConfirm()">YES</button>
    <button type="button" class="btn btn-secondary" (click)="onDismiss()">CANCEL</button> -->
    </div> 
    </p-dialog>   
</div>




<div *ngIf="placeholderErrorDialog">
  <p-dialog  header="Alert" [(visible)]="placeholderErrorDialog" 
    modal="true" 
    appendTo="body" 
    [draggable]="false" 
    [resizable]="false" 
    [modal]="true" 
    [style]="{width: '30vw'}" >
 
  <hr>

  <div class="row mt-2">
    <div class="w-100"><p>Your email contains unpopulated placeholder. </p></div>
    <div class="clearfix"></div>

    <div class="w-100"><p>It is highlighted in Red.</p></div>
    <p><b>Please replace or remove before sending.</b></p>
  </div>

  <hr>

  <p-footer>
    <button class="btn btn-secondary" (click)="placeholderErrorDialog = false">Ok</button>
  </p-footer>


</p-dialog>
</div>